
import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
    title?: string;
    description?: string;
    imageUrl?: string;
    url?: string;
    type?: 'website' | 'product';
    productData?: {
        name: string;
        description: string;
        price: number;
        currency: string;
        imageUrl: string;
    };
}

export const SEOHead: React.FC<SEOHeadProps> = ({ 
    title = "Sälj Kaffe & Tjäna Pengar till Klasskassan | CoffeeNova", 
    description = "Tjäna pengar till klasskassan eller laget genom att sälja premiumkaffe. Inga utlägg, hög vinst och egen webbshop till varje säljare.", 
    imageUrl = "https://images.unsplash.com/photo-1497935586351-b67a49e012bf?auto=format&fit=crop&q=80&w=1200", 
    url = window.location.href,
    type = 'website',
    productData
}) => {
    
    // Construct JSON-LD for Products (Rich Snippets)
    let jsonLd = null;
    if (type === 'product' && productData) {
        jsonLd = {
            "@context": "https://schema.org/",
            "@type": "Product",
            "name": productData.name,
            "image": productData.imageUrl,
            "description": productData.description,
            "brand": {
                "@type": "Brand",
                "name": "CoffeeNova"
            },
            "offers": {
                "@type": "Offer",
                "priceCurrency": productData.currency,
                "price": productData.price,
                "availability": "https://schema.org/InStock",
                "url": url
            }
        };
    } else {
        // Default WebSite JSON-LD
        jsonLd = {
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "CoffeeNova",
            "url": "https://coffeenova.se",
            "potentialAction": {
                "@type": "SearchAction",
                "target": "https://coffeenova.se/#/store?q={search_term_string}",
                "query-input": "required name=search_term_string"
            }
        };
    }

    return (
        <Helmet>
            {/* Standard Meta */}
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={imageUrl} />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={url} />
            <meta property="twitter:title" content={title} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={imageUrl} />

            {/* Structured Data (JSON-LD) */}
            {jsonLd && (
                <script type="application/ld+json">
                    {JSON.stringify(jsonLd)}
                </script>
            )}
        </Helmet>
    );
};
